import { each } from '../lib/util';
import { duration } from '../lib/const';

export default ((window) => {
    const animatableItems = document.querySelectorAll('[data-js-animate]');

    let animArr;
    const scrollOffset = 20;

    calculateElementPositions();

    window.addEventListener('scroll', animate);
    window.addEventListener('resize', calculateElementPositions);

    
    function animate() {
        const bottomOfWindow = window.pageYOffset + window.innerHeight;

        let i = animArr.length;
        while(i--) {
            const item = animArr[i];
            
            if(item.offset < (bottomOfWindow - scrollOffset)) {
                item.el.classList.remove('animate--before');
                item.el.classList.add('animate');
                setTimeout(() => {
                    item.el.classList.add('animate--done');
                }, item.duration);
                
                animArr.splice(i, 1);
            }

        }
    }

    function calculateElementPositions() {
        animArr = [];

        each(animatableItems, (item) => {
            item.classList.add('animate--before');
            let offset = item.getBoundingClientRect().top + window.pageYOffset;
            offset += item.dataset.animateSide && item.dataset.animateSide === 'center' ? item.offsetHeight / 2 : item.offsetHeight;

            const duration = item.dataset.animateDuration ? parseInt(item.dataset.animateDuration) : duration;
            animArr.push({
                offset: offset - 60,
                el: item,
                duration: duration
            });
        });

        animate();
    }

})(window)